module.exports = __webpack_public_path__ + "img/quincy_cover.9b05c1e5.jpg";